<template>
  <div class="playlist-container">
    <div class="main-content">
      <el-card class="playlist-title-card">
        <h1 class="playlist-title">雪音时光收藏馆</h1>
        <p class="playlist-description">
          雪音点歌搜索功能，输入歌曲名称即可查询目标曲目是否在公开曲库中。
        </p>
      </el-card>

      <!-- 主要 Tab 切换 -->
      <el-card class="main-tabs-section">
        <el-tabs v-model="activeMainTab" @tab-click="handleMainTabChange" class="main-tabs">
          <el-tab-pane label="雪音歌单" name="xueyin">
            <span slot="label">
              <i class="el-icon-headset"></i> 雪音歌单
            </span>
          </el-tab-pane>
          <el-tab-pane label="抖音禁止曲目" name="forbidden">
            <span slot="label">
              <i class="el-icon-warning-outline"></i> 抖音禁止曲目
            </span>
          </el-tab-pane>
        </el-tabs>
      </el-card>

      <!-- 雪音歌单内容 -->
      <div v-if="activeMainTab === 'xueyin'">
        <el-card class="search-section">
          <div class="search-input-container">
            <el-input 
              v-model="xueyinSearchQuery" 
              placeholder="请输入歌曲名称进行搜索" 
              prefix-icon="el-icon-search" 
              clearable
              @input="handleXueyinSearch" 
            />
            <div class="search-tips">
              <span class="tip-text">输入歌曲名称自动搜索，查看雪音是否会唱</span>
            </div>
          </div>
        </el-card>

        <el-card class="results-section" v-if="showXueyinResults">
          <div v-if="xueyinSearchResults.length > 0" class="results-container">
            <h3 class="results-title">
              <i class="el-icon-success"></i> 搜索结果 (共找到 {{ xueyinSearchResults.length }} 首歌曲)
            </h3>
            <el-table :data="xueyinSearchResults" style="width: 100%" class="results-table">
              <el-table-column prop="song" label="歌曲名称" width="400" />
              <el-table-column prop="category" label="分类" width="200" />
            </el-table>
          </div>
          <div v-else-if="xueyinSearchQuery.trim() !== ''" class="no-results">
            <i class="el-icon-info"></i>
            <p>主包还没把握&gt; &lt;再等等吧</p>
          </div>
        </el-card>

        <el-card class="categories-section">
          <div class="category-tabs">
            <el-tabs v-model="xueyinCategory" @tab-click="handleXueyinCategoryChange">
              <el-tab-pane label="流行歌曲" name="popular"></el-tab-pane>
              <el-tab-pane label="古风/国风" name="chineseStyle"></el-tab-pane>
            </el-tabs>
          </div>
          <div class="category-songs" v-if="xueyinGroupedSongs">
            <div v-for="(songs, letter) in xueyinGroupedSongs" :key="letter" class="song-group">
              <div class="letter-header">
                <h4>{{ letter }}</h4>
                <div class="divider"></div>
              </div>
              <div class="song-list">
                <div v-for="song in songs" :key="song" class="song-item">
                  {{ song }}
                </div>
              </div>
            </div>
          </div>
        </el-card>
      </div>

      <!-- 抖音禁止歌单内容 -->
      <!-- <div v-else-if="activeMainTab === 'forbidden'">
        <el-card class="search-section">
          <div class="search-input-container">
            <el-input 
              v-model="forbiddenSearchQuery" 
              placeholder="请输入歌曲名称进行搜索" 
              prefix-icon="el-icon-search" 
              clearable
              @input="handleForbiddenSearch" 
            />
            <div class="search-tips">
              <span class="tip-text">搜索抖音禁止歌曲，若在列表中则不可播放/点唱/直播</span>
            </div>
          </div>
        </el-card>

        <el-card class="results-section" v-if="showForbiddenResults">
          <div v-if="forbiddenSearchResults.length > 0" class="results-container">
            <h3 class="results-title">
              <i class="el-icon-warning"></i> 禁止歌曲 (共找到 {{ forbiddenSearchResults.length }} 首)
            </h3>
            <el-table :data="forbiddenSearchResults" style="width: 100%" class="results-table">
              <el-table-column prop="song" label="歌曲名称" width="400" />
              <el-table-column prop="message" label="提示信息" width="200" />
            </el-table>
          </div>
          <div v-else-if="forbiddenSearchQuery.trim() !== ''" class="no-results">
            <i class="el-icon-circle-check"></i>
            <p>未在禁止歌单中找到该歌曲，可以正常使用</p>
          </div>
        </el-card>

        <el-card class="categories-section">
          <div class="category-tabs">
            <el-tabs v-model="forbiddenTabMode" @tab-click="handleForbiddenTabMode">
              <el-tab-pane label="全部禁止歌曲" name="all"></el-tab-pane>
              <el-tab-pane label="按拼音首字母" name="grouped"></el-tab-pane>
            </el-tabs>
          </div>
          <div v-if="forbiddenTabMode === 'all'" class="full-list">
            <div class="song-list full">
              <div v-for="song in allForbiddenSongs" :key="song" class="song-item">
                {{ song }}
              </div>
            </div>
          </div>
          <div v-else-if="forbiddenTabMode === 'grouped'" class="category-songs">
            <div v-for="(songs, letter) in groupedForbiddenSongs" :key="letter" class="song-group">
              <div class="letter-header">
                <h4>{{ letter }}</h4>
                <div class="divider"></div>
              </div>
              <div class="song-list">
                <div v-for="song in songs" :key="song" class="song-item">
                  {{ song }}
                </div>
              </div>
            </div>
          </div>
        </el-card>
      </div> -->
    </div>
  </div>
</template>

<script>
import { groupedPopularSongs, groupedChineseStyleSongs } from '@/assets/data/songData.js';
import { forbiddenSongsList, groupedForbiddenSongs } from '@/assets/data/forbiddenSongs.js';

export default {
  name: 'Playlist',
  data() {
    return {
      // 主 Tab
      activeMainTab: 'xueyin',
      
      // 雪音歌单相关
      xueyinSearchQuery: '',
      xueyinSearchResults: [],
      showXueyinResults: false,
      xueyinCategory: 'popular',
      
      // 抖音禁止歌单相关
      forbiddenSearchQuery: '',
      forbiddenSearchResults: [],
      showForbiddenResults: false,
      forbiddenTabMode: 'all',
      allForbiddenSongs: forbiddenSongsList,
      groupedForbiddenSongs: groupedForbiddenSongs
    };
  },
  computed: {
    xueyinGroupedSongs() {
      if (this.xueyinCategory === 'popular') {
        return groupedPopularSongs;
      } else {
        return groupedChineseStyleSongs;
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      const el = this.$el.querySelector('.main-content');
      el && (el.scrollTop = 0);
      window.scrollTo(0, 0);
    });
  },
  activated() {
    this.$nextTick(() => {
      const el = this.$el.querySelector('.main-content');
      el && (el.scrollTop = 0);
      window.scrollTo(0, 0);
    });
  },
  methods: {
    handleMainTabChange(tab) {
      this.activeMainTab = tab.name;
    },
    
    handleXueyinSearch() {
      this.showXueyinResults = this.xueyinSearchQuery.trim() !== '';
      if (this.showXueyinResults) {
        const query = this.xueyinSearchQuery.toLowerCase();
        this.xueyinSearchResults = [];

        Object.values(groupedPopularSongs).forEach(songs => {
          songs.forEach(song => {
            if (song.toLowerCase().includes(query)) {
              this.xueyinSearchResults.push({ song, category: '流行歌曲' });
            }
          });
        });

        Object.values(groupedChineseStyleSongs).forEach(songs => {
          songs.forEach(song => {
            if (song.toLowerCase().includes(query)) {
              this.xueyinSearchResults.push({ song, category: '古风/国风' });
            }
          });
        });
      }
    },
    
    handleXueyinCategoryChange(tab) {
      this.xueyinCategory = tab.name;
    },
    
    handleForbiddenSearch() {
      this.showForbiddenResults = this.forbiddenSearchQuery.trim() !== '';
      if (this.showForbiddenResults) {
        const query = this.forbiddenSearchQuery.toLowerCase().trim();
        this.forbiddenSearchResults = this.allForbiddenSongs
          .filter(song => song.toLowerCase().includes(query))
          .map(song => ({ song, message: '禁止播放/点唱/直播' }));
      }
    },
    
    handleForbiddenTabMode(tab) {
      this.forbiddenTabMode = tab.name;
    }
  }
};
</script>

<style scoped>
.playlist-container {
  padding: 20px;
  max-width: 1200px;
  margin: 0 auto;
  position: relative;
  min-height: 100vh;
}

.main-content {
  width: 100%;
}

.playlist-title-card {
  text-align: center;
  margin-bottom: 30px;
  border-radius: 10px;
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
  border: none;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.playlist-title {
  font-size: 28px;
  color: #ffad32;
  margin-bottom: 10px;
  letter-spacing: 2px;
  font-weight: bold;
}

.playlist-description {
  font-size: 16px;
  color: #666;
  line-height: 1.6;
}

/* 主 Tab 样式 - 与分类 Tab 保持一致 */
.main-tabs-section {
  margin-bottom: 20px;
}

.main-tabs >>> .el-tabs__header {
  margin: 0;
}

.main-tabs >>> .el-tabs__item {
  font-size: 16px;
}

.main-tabs >>> .el-tabs__item.is-active {
  color: #ffad32;
}

.main-tabs >>> .el-tabs__active-bar {
  background-color: #ffad32;
}

.search-section {
  margin-bottom: 20px;
  padding: 20px;
}

.search-input-container .el-input {
  width: 100%;
  max-width: 500px;
}

.search-tips {
  margin-top: 10px;
  color: #909399;
  font-size: 16px;
}

.results-section {
  margin-bottom: 20px;
  padding: 20px;
}

.results-container {
  margin-top: 10px;
}

.results-title {
  color: #606266;
  font-size: 20px;
  margin-bottom: 15px;
  font-weight: normal;
}

.no-results {
  text-align: center;
  padding: 40px 20px;
  color: #909399;
}

.no-results i {
  font-size: 64px;
  margin-bottom: 10px;
  display: block;
}

.no-results p {
  font-size: 18px;
}

.categories-section {
  margin-bottom: 20px;
  padding: 20px;
}

.category-tabs {
  margin-bottom: 20px;
}

.category-tabs .el-tabs__item {
  font-size: 16px;
}

.category-songs {
  margin-top: 20px;
}

.song-group {
  margin-bottom: 30px;
}

.letter-header h4 {
  color: #303133;
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 5px;
}

.divider {
  height: 2px;
  background: linear-gradient(90deg, #ffa117 0%, transparent 100%);
  margin-bottom: 15px;
}

.song-list {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 10px;
}

.full-list {
  max-height: 600px;
  overflow-y: auto;
}

.song-list.full {
  grid-template-columns: repeat(4, 1fr);
}

.song-item {
  padding: 8px 0;
  color: #606266;
  font-size: 18px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  border-bottom: 1px dashed #ebeef5;
}

.results-table {
  margin-top: 10px;
}

.results-table .el-table__cell {
  font-size: 20px;
  height: 60px;
  padding: 12px 0;
}

.results-table .el-table__header th {
  font-size: 18px;
  height: 50px;
}
</style>